/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Works_Heading_TaglineInputs */

const en_works_heading_tagline = /** @type {(inputs: Works_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`projects & experiments`)
};

const ar_works_heading_tagline = /** @type {(inputs: Works_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشاريع وتجارب`)
};

const bn_works_heading_tagline = /** @type {(inputs: Works_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রজেক্ট আর নতুন কিছু চেষ্টা`)
};

const de_works_heading_tagline = /** @type {(inputs: Works_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekte & Experimente`)
};

const es_works_heading_tagline = /** @type {(inputs: Works_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`proyectos y experimentos`)
};

const fr_works_heading_tagline = /** @type {(inputs: Works_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`projets et expériences`)
};

const pt_works_heading_tagline = /** @type {(inputs: Works_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`projetos e experimentos`)
};

const zh_works_heading_tagline = /** @type {(inputs: Works_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目和实验`)
};

const tr_works_heading_tagline = /** @type {(inputs: Works_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`projeler ve deneyler`)
};

const ru_works_heading_tagline = /** @type {(inputs: Works_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`проектов и экспериментов`)
};

const pl_works_heading_tagline = /** @type {(inputs: Works_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`projekty i eksperymenty`)
};

/**
* | output |
* | --- |
* | "projects & experiments" |
*
* @param {Works_Heading_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const works_heading_tagline = /** @type {((inputs?: Works_Heading_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Works_Heading_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_works_heading_tagline(inputs)
	if (locale === "bn") return bn_works_heading_tagline(inputs)
	if (locale === "de") return de_works_heading_tagline(inputs)
	if (locale === "es") return es_works_heading_tagline(inputs)
	if (locale === "fr") return fr_works_heading_tagline(inputs)
	if (locale === "pt") return pt_works_heading_tagline(inputs)
	if (locale === "zh") return zh_works_heading_tagline(inputs)
	if (locale === "tr") return tr_works_heading_tagline(inputs)
	if (locale === "ru") return ru_works_heading_tagline(inputs)
	if (locale === "pl") return pl_works_heading_tagline(inputs)
	return en_works_heading_tagline(inputs)
});